import { api } from './api';

// Types for tenant settings
export interface SearchSettings {
  keyword_matching_enabled: boolean;
}

export interface FeatureSettings {
  ai_summary: boolean;
  auto_tagging: boolean;
}

export interface TenantSettings {
  theme: string;
  language: string;
  features: FeatureSettings;
  search: SearchSettings;
}

export interface TenantSettingsResponse {
  settings: TenantSettings;
  tenant_id: string;
  tenant_name: string;
}

export interface UpdateTenantSettingsRequest {
  search?: Partial<SearchSettings>;
  features?: Partial<FeatureSettings>;
  theme?: string;
  language?: string;
}

class SettingsService {
  /**
   * Get current tenant settings
   * Requires USER role
   */
  async getTenantSettings(): Promise<TenantSettingsResponse> {
    return api.get<TenantSettingsResponse>('/settings/tenant');
  }

  /**
   * Update tenant settings
   * Requires ADMIN role
   */
  async updateTenantSettings(
    settings: UpdateTenantSettingsRequest
  ): Promise<TenantSettingsResponse> {
    return api.put<TenantSettingsResponse>('/settings/tenant', settings);
  }

  /**
   * Update search settings specifically
   * Convenience method for updating only search-related settings
   */
  async updateSearchSettings(
    searchSettings: Partial<SearchSettings>
  ): Promise<TenantSettingsResponse> {
    return this.updateTenantSettings({ search: searchSettings });
  }
}

export const settingsService = new SettingsService();
